import {GameDialog, GameObject} from "../base";
import {AbstractText} from "pixi.js";
import {Button} from "../flump";

export abstract class AbstractInfoDialog extends GameDialog {

  protected _text = '';
  protected _tf?: AbstractText | null;
  protected _btnCallback?: Function | null;

  constructor(text: string, btnCallback: Function | null = null) {
    super();
    this._text = text;
    this._btnCallback = btnCallback;
  }

  override onAdded() {
    super.onAdded();
    this.createDialog();
    this.show();
  }

  override get tabletMultiplier() {
    return 1;
  }

  override destroy() {
    this._tf = GameObject.destroy(this._tf);
    this._btnCallback = null;
    super.destroy();
  }

  override get dialogContentMoldName(): string {
    return 'dialog_info';
  }

  override getCenterY(): number {
    return this.root.fixedStageSafeHeight / 2;
  }

  override createDialog() {
    super.createDialog();

    this._dialogContent!.getButtonByLabel('btn_confirm').visible = false;
    this._dialogContent!.getButtonByLabel('btn_cancel').visible = false;

    let btnCancel:Button = this._dialogContent!.getChildByLabel('btn_ok') as Button;
    btnCancel.setText(this.getButtonText());
    btnCancel.startPulsating();
    btnCancel.clickCallback = this.onButtonClick.bind(this);

    const iconPlacer = this._dialogContent!.getPlacerByLabel('icon');
    iconPlacer.place(this.getIcon())
      .fitHeight(true, true)
      .fitWidth(true, false)
      .alignCenter();

    const textPlacer = this._dialogContent!.getPlacerByLabel('text');
    this._tf = this.root.mainTextLib.createBitmapText(this.getText(), textPlacer.width, textPlacer.height);
    textPlacer.place(this._tf)
      .fitWidth(true, true)
      .fitHeight(true, false)
      .alignCenter();
  }

  protected getText(): string {
    return this._text;
  }

  protected getIcon() {
    return this.root.uiLib.create("icon_info");
  }

  protected getButtonText() {
    return 'OK';
  }

  protected onButtonClick() {
    this.onButtonClose();
    if (this._btnCallback) {
      this._btnCallback();
    }
  }
}
